import { render, staticRenderFns } from "./SingleScore.vue?vue&type=template&id=4bf947a4&"
import script from "./SingleScore.vue?vue&type=script&lang=js&"
export * from "./SingleScore.vue?vue&type=script&lang=js&"
import style0 from "./SingleScore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports